import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const PrimarySmallButton = withStyles((theme) => ({
    root: {
        color: theme.overrides.MuiButton.textPrimary.color,
        backgroundColor: '#ffffff',
        '&:hover': {
            backgroundColor: 'rgb(244, 170, 50,0.3)',
        },
        '&:active': {
            backgroundColor: 'rgb(244, 170, 50,0.3)',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: 'rgb(244, 170, 50,0.3)',
        },
        borderRadius: 10,
        padding: '7px 10px',
        border: 'solid 2px  rgb(244, 170, 50,0.3)' 
    },
    label: {
        fontSize: 9,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.36,
        lineHeight: '11px',
        marginTop: 2
    }
}))(Button);

const PrimaryMediumButton = withStyles((theme) => ({
    root: {
        color: theme.overrides.MuiButton.textPrimary.color,
        backgroundColor: '#ffffff',
        '&:hover': {
            backgroundColor: 'rgb(244, 170, 50,0.3)',
        },
        '&:active': {
            backgroundColor: 'rgb(244, 170, 50,0.3)',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: 'rgb(244, 170, 50,0.3)',
        },
        borderRadius: 10,
        padding: '12px 16px',
        borderColor: 'solid 2px #e5f1f8'
    },
    label: {
        fontSize: 11,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.44,
        lineHeight: '11px',
    }
}))(Button);

function CustomizeButton({ label, onClick, large, ...props }) {
    if (!large)
        return (
            <PrimarySmallButton {...props} size='small' onClick={onClick}>{label}</PrimarySmallButton>
        );
    return <PrimaryMediumButton {...props} size='medium' onClick={onClick}>{label}</PrimaryMediumButton>
}


CustomizeButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    large: PropTypes.bool,
}

export default CustomizeButton;
